// Landscape-only support (§10). The gate is shown by a CSS media query when the
// device is held portrait; we also try to lock orientation on first gesture.

export class OrientationGate {
  constructor(parent: HTMLElement) {
    const el = document.createElement('div');
    el.className = 'orientation-gate';
    el.innerHTML = `
      <div class="rot">📱</div>
      <h2>Rotate your device</h2>
      <p>Panda Roll plays in landscape.</p>
    `;
    parent.appendChild(el);
  }

  /** Best-effort orientation lock; safe to fail (desktop / unsupported). */
  async tryLock(): Promise<void> {
    try {
      const orientation = screen.orientation as ScreenOrientation & {
        lock?: (o: string) => Promise<void>;
      };
      await orientation.lock?.('landscape');
    } catch {
      /* unsupported or requires fullscreen — the CSS gate covers it */
    }
  }
}
